/**
 * Week arithmetic for the agenda.
 *
 * Everything here works in the browser's local timezone, which is the one the
 * user is reading the grid in. Meetings arrive as UTC instants and are placed
 * by their local day — a 23:30 UTC meeting belongs to the next day for someone
 * in Brussels, and putting it on the wrong column is worse than any rounding.
 */

export function startOfDay(date: Date): Date {
  const start = new Date(date);
  start.setHours(0, 0, 0, 0);
  return start;
}

/*
 * Calendar arithmetic, not 24-hour arithmetic. A day is 23 or 25 hours long
 * twice a year, so adding milliseconds slides the whole week off midnight and
 * the grid renders one day twice.
 */
export function addDays(date: Date, days: number): Date {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

/** The Monday (or Sunday) on or before `date`, at midnight. */
export function startOfWeek(date: Date, weekStartsOn: 'monday' | 'sunday'): Date {
  const start = startOfDay(date);
  const offset = weekStartsOn === 'monday' ? (start.getDay() + 6) % 7 : start.getDay();
  return addDays(start, -offset);
}

export function isSameDay(a: Date, b: Date): boolean {
  return startOfDay(a).getTime() === startOfDay(b).getTime();
}

/** The `count` consecutive days starting at `start`. */
export function daysFrom(start: Date, count: number): Date[] {
  return Array.from({ length: count }, (_, index) => addDays(start, index));
}

export function durationMinutes(startsAt: string, endsAt: string): number {
  return Math.max(0, Math.round((Date.parse(endsAt) - Date.parse(startsAt)) / 60_000));
}
